<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-desktop`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M33 40a1 1 0 011 1v2a1 1 0 01-1 1H15a1 1 0 01-1-1v-2a1 1 0 011-1h18zM43 4a2 2 0 012 2v28a2 2 0 01-2 2H5a2 2 0 01-2-2V6a2 2 0 012-2h38zM7 29v3h34v-3H7zm0-4h34V8H7v17z"/></svg>
</template>
<script>

export default {
  name: 'IconDesktop',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
